import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'
import { vpnConnectionStateHandler } from '../../../helpers/vpn-connection-state-handler';
import { useHistory } from 'react-router-dom';
import styles from './vpn-verify-styles.module.css';

import store from '../../../redux/store';
import { setPageHistoryPathname } from '../../../redux/actions/preferencesActions';
import config from '../../../config/env_variables';

const VPN_RESTRICTED_COUNTRY = 'IN';
const ROUTES = {
    UNAUTHORIZED: '/403',
    HOME: '/'
} as const;

interface VpnValidationProps {
    children: React.ReactNode;
}

const VpnValidation: React.FC<VpnValidationProps> = ({ children }) => {

    const { agentDetails } = useSelector((state: any) => state.contactCenter)
    const [isValidating, setIsValidating] = useState(true);
    const history = useHistory();

    const { routingProfile = '' } = agentDetails || {};

    React.useEffect(() => {
        store.dispatch(setPageHistoryPathname(window.location.pathname));
    }, [history, window.location.pathname]);

    useEffect(() => {
        const validateIP = async () => {
            try {
                const countryCode = await vpnConnectionStateHandler.getUserGeoCountry();
                sessionStorage.setItem('VpnCountryCode', countryCode)

                if (countryCode === VPN_RESTRICTED_COUNTRY) {
                    const isVpnConnected = await vpnConnectionStateHandler.checkVpnStatus(false);

                    if (isVpnConnected) {
                        if (window.location.pathname === ROUTES.UNAUTHORIZED) {
                            history.push(ROUTES.HOME);
                        }
                    } else {
                        history.push(ROUTES.UNAUTHORIZED);
                    }
                }

            } catch (error) {
                console.error('VPN_DISCONNECT_CHECK - Error validating IP:', error);
            } finally {
                setIsValidating(false);
            }
        }

        if (config.DISABLE_VPN_CHECK) {
            console.log('DEBUG - Skipping VPN validation, DISABLE_VPN_CHECK is set (local dev)');
            setIsValidating(false);
            return;
        }

        const isVoiceAgent = sessionStorage.getItem('isVoiceAgent') === 'true';
        if(routingProfile && isVoiceAgent) {
            console.log('DEBUG - Calling VPN');
            validateIP();
        }
        else {
            console.log('DEBUG - Skipping VPN validation for non-voice agents or missing routing profile');
            setIsValidating(false);
        }
    }, [history, routingProfile]);


    if (isValidating) {
        return (
            <div className={styles.loadingContainer}>
                Verifying VPN Connection<span className={styles.ellipsis}></span>
            </div>
        );
    }

    return <>{children}</>;
};

export default VpnValidation;